import { embedFilter } from '../sharedFilters'

const DATASET_KEY = 'security_managment_flash_alert'

export default {
  key: 'security_managment_flash_alert',
  label: 'GSMS - Flash Alert',
  timeColumn: 'security_managment_flash_alert.date_sent',
  permission: { action: 'reporting', subject: 'Widget' },

  tables: {
    security_managment_flash_alert: ["id", "id_security_managment_incident", "flash_alert_id", "building_code", "alert_body", "applicable_ccir", "risk_description", "additional_location_information", "alert_status", "subject_line", "date_sent", "created_by", "created_on", "last_updated_by", "last_updated_on", "flash_alert_id_row", "flash_alert_id_count", "created_at", "updated_at"],
    security_managment_facility: ["id", "facility_id", "csis_building_status", "crs_building_status", "region", "country", "state", "city", "zip", "address", "building_code", "facility_name", "floor_code", "occupied", "has_data_center", "has_child_care", "number_of_floors", "occupied_floors", "owned_or_leased", "vacancy_date", "headcount", "updated_headcount", "primary_facility_type", "source_instance", "created_at", "updated_at"],
    security_managment_incident: ["id", "incident_id", "title", "incident_location", "building_code", "incident_category", "incident_subcategory", "incident_type", "actual_or_attempted", "status", "date_occurred", "date_reported", "created_date", "closed_date", "description_of_incident", "reporter_soeid", "reporter_type", "reporting_entity", "alert_received_through", "other_alert_description", "alarm_triggered", "owner_soeid", "law_enforcement_notified", "cctv_checked", "cctv_start_time", "cctv_end_time", "contact_information", "responder_type", "responder_name", "responder_phone", "responder_email", "incident_count", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  csvConfig: {
    withTables: 'security_managment_flash_alert',
    columns: 'security_managment_facility.building_code,security_managment_facility.facility_name,security_managment_facility.address,security_managment_facility.city,security_managment_facility.state,security_managment_facility.country,security_managment_facility.primary_facility_type,security_managment_facility.csis_building_status',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'security_managment_facility.building_code', label: 'Instalacion' },
    { key: 'security_managment_facility.facility_name', label: 'Nombre instalacion' },
    { key: 'security_managment_facility.address', label: 'Direccion' },
    { key: 'security_managment_facility.city', label: 'Ciudad' },
    { key: 'security_managment_facility.state', label: 'Estado' },
    { key: 'security_managment_facility.country', label: 'Pais' },
    { key: 'security_managment_flash_alert.alert_status', label: 'Estatus' },
    { key: 'security_managment_flash_alert.risk_description', label: 'Descripcion' },
    { key: 'security_managment_flash_alert.applicable_ccir', label: 'CCIR' },
    { key: 'security_managment_flash_alert.flash_alert_id', label: 'Referencia' },
    { key: 'security_managment_facility.primary_facility_type', label: 'Tipo' },
    { key: 'security_managment_facility.csis_building_status', label: 'Nivel' },
    { key: 'security_managment_flash_alert.date_sent', label: 'Fecha', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'security_managment_facility.building_code', 'Instalacion', 'installation'),
    embedFilter(DATASET_KEY, 'security_managment_facility.facility_name', 'Nombre instalacion', 'facility_name'),
    embedFilter(DATASET_KEY, 'security_managment_facility.city', 'Ciudad', 'city'),
    embedFilter(DATASET_KEY, 'security_managment_facility.country', 'Pais', 'country'),
    embedFilter(DATASET_KEY, 'security_managment_flash_alert.alert_status', 'Estatus', 'status'),
    embedFilter(DATASET_KEY, 'security_managment_flash_alert.risk_description', 'Descripcion', 'name'),
    embedFilter(DATASET_KEY, 'security_managment_flash_alert.applicable_ccir', 'CCIR', 'group'),
    embedFilter(DATASET_KEY, 'security_managment_flash_alert.flash_alert_id', 'Referencia', 'reference'),
    embedFilter(DATASET_KEY, 'security_managment_facility.primary_facility_type', 'Tipo', 'type'),
    embedFilter(DATASET_KEY, 'security_managment_facility.csis_building_status', 'Nivel', 'level'),
    embedFilter(DATASET_KEY, 'security_managment_facility.state', 'Estado', 'state'),
  ],

    dateGrouping: {
    column: 'security_managment_flash_alert.date_sent',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
